import React, { useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import login from "../Assets/Images/loginn.jpg";
import logo from "../Assets/Images/remesalogo.png";
import { useDataContext } from "../Context/dataContext";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { setAccessToken, url } = useDataContext();
  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState("");

    const fetchData = async (email, password) => {
    try {
      const response = await axios.get(
        `${url}/Auth/login/${email.toLowerCase()}/${password.toLowerCase()}`
      );
      if (response.data.success !== true) {
        setErrorMsg(response.data.message || "Error al iniciar sesión");
      } else {
        setErrorMsg("");
        setAccessToken(response.data.data);
        history.push("/Changes");
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Error al iniciar sesión");
      await axios.get(`${url}/Auth/logout/${email.toLowerCase()}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    const loginSuccessful = await fetchData(email, password);

    if (loginSuccessful) {
      return;
    }
  };

  return (
    <div className="login-page">
      {/* Error message modal */}
      {errorMsg && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem 2.5rem",
              borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              textAlign: "center",
              minWidth: "300px",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                color: "#ff9800",
                marginBottom: "1rem",
              }}
            >
              ⚠️
            </div>
            <div style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
              ¡Advertencia!
            </div>
            <div>{errorMsg}</div>
            <button
              style={{
                marginTop: "1.5rem",
                padding: "0.5rem 1.5rem",
                borderRadius: "8px",
                border: "none",
                background: "#ff9800",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => setErrorMsg("")}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
      {/* Desktop layout */}
      <div className="login-container">
        <div className="login-image">
          <img src={login} alt="Ilustración Remesa" />
        </div>

        <motion.div
          className="login-form-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/">
            <motion.img
              src={logo}
              alt="Remesa España"
              className="login-logo"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </Link>

          <form className="login-form" onSubmit={handleSubmit}>
            <label>
              <FaUser className="icon" />
              <input
                type="email"
                placeholder="Correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label>
              <FaLock className="icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
                aria-label="Mostrar u ocultar contraseña"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </label>

            <button type="submit" disabled={loading} className="login-button">
              {loading ? "Cargando..." : "Iniciar Sesión"}
            </button>

            <div className="login-links">
              <Link to="/Recover">¿Olvidaste la contraseña?</Link>
              <Link to="/Register">¿No tienes cuenta? Regístrate</Link>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export { Login };
